import { LmIconFilledMiscBulb, LmIconOutlineMiscBulb } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconScienceProjectsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineMiscBulb {...rest} /> : <LmIconFilledMiscBulb {...rest} />;

export default IconScienceProjectsCommon;
